@let _name = uiInfo().name;
@let _logo = uiInfo().logo;
@let _mode = mode();

@switch (_mode) {
  @case (NavigationBarMode.INLINE) {
    <div class="flex flex-row gap-6">
      <div class="flex flex-row items-center flex-1">
        <div class="flex items-center justify-center w-10">
          <img crossorigin [src]="_logo" style="height: 20px" />
        </div>

        <div class="ml-1 whitespace-nowrap">
          <span
            class="text-xl"
            [ngClass]="{
              'text-[#fab439]': !(
                product === SoftwareProduct.PMS ||
                product === SoftwareProduct.ROCKET ||
                product === SoftwareProduct.ADMIN ||
                product === SoftwareProduct.BOTMASTER
              ),
              'text-sky-700':
                product === SoftwareProduct.PMS ||
                product === SoftwareProduct.ROCKET ||
                product === SoftwareProduct.ADMIN ||
                product === SoftwareProduct.BOTMASTER
            }"
          >
            {{ _name | lowercase | titlecase }}
          </span>
        </div>
      </div>

      <div class="flex flex-row gap-4">
        @for (
          item of navigationMenu;
          track (item.url || item.title + $index) + protectedRoutesRevision()
        ) {
          <div class="py-2 flex flex-row gap-1">
            <div>
              <span
                [ngClass]="{ underline: item.active }"
                class="text-sm text-slate-900 cursor-pointer select-none"
                (click)="onPrimaryMenuItemClick(null, null, item, $index)"
                >{{ item.title }}</span
              >
            </div>
          </div>
        }
      </div>
    </div>
  }
  @default {
    <div
      class="flex flex-col flex-1 bg-primary-container"
      (mouseleave)="onMouseLeave()"
    >
      <div class="flex flex-row items-center overflow-hidden pt-1 pr-1 mb-2">
        <div class="flex flex-row items-center flex-1">
          <div class="flex items-center justify-center w-10">
            <img crossorigin [src]="_logo" style="height: 20px" />
          </div>

          <div class="ml-1 whitespace-nowrap">
            <span
              class="text-base"
              [ngClass]="{
                'text-[#fab439]': !(
                  product === SoftwareProduct.PMS ||
                  product === SoftwareProduct.ROCKET ||
                  product === SoftwareProduct.ADMIN ||
                  product === SoftwareProduct.BOTMASTER
                ),
                'text-sky-700':
                  product === SoftwareProduct.PMS ||
                  product === SoftwareProduct.ROCKET ||
                  product === SoftwareProduct.ADMIN ||
                  product === SoftwareProduct.BOTMASTER
              }"
            >
              {{ _name | lowercase | titlecase }}
            </span>
          </div>
        </div>

        <div class="ml-auto">
          @if (
            product === SoftwareProduct.PMS ||
            product === SoftwareProduct.ROCKET ||
            product === SoftwareProduct.ADMIN ||
            product === SoftwareProduct.BOTMASTER
          ) {
            <dx-button
              [icon]="
                mode() === 'block'
                  ? 'fa-light fa-square-chevron-left text-slate-400'
                  : 'fa-light fa-square-chevron-right text-slate-400'
              "
              stylingMode="text"
              (onClick)="onToogleNavigationBarMode()"
            ></dx-button>
          }
        </div>
      </div>

      <div
        [ngClass]="{ 'pb-2': PLATFORM === PlatformType.DESKTOP }"
        class="flex flex-col flex-1"
      >
        <div class="relative flex-1">
          <div
            class="absolute inset-0 overflow-x-hidden overflow-y-auto scrollbar scrollbar-thumb-slate-400 scrollbar-track-transparent"
          >
            @for (
              item of navigationMenu;
              track (item.url || item.title + $index) +
                protectedRoutesRevision()
            ) {
              <div class="flex flex-col group mb-1.5">
                <!-- item -->
                <div
                  (click)="
                    item &&
                      !item.disabled &&
                      onPrimaryMenuItemClick(
                        subMenuContainer,
                        subMenuWrapper,
                        item,
                        $index
                      )
                  "
                  class="flex flex-row flex-1"
                >
                  <div
                    class="relative flex flex-row flex-1 cursor-pointer"
                    [ngClass]="{
                      'cursor-not-allowed': item.disabled,
                      'opacity-50': item.disabled
                    }"
                  >
                    <div
                      class="flex-1 flex flex-row transition-colors hover:bg-slate-200 rounded-md"
                    >
                      <div
                        class="relative flex items-center justify-center w-10"
                      >
                        <div
                          [ngStyle]="{
                            backgroundColor: item.active
                              ? item.color || null
                              : null
                          }"
                          class="flex items-center justify-center p-1 rounded-md aspect-square"
                        >
                          <i
                            [ngStyle]="{
                              color: !item.active ? item.color || null : null
                            }"
                            [ngClass]="{
                              'text-slate-50': item.color && item.active,
                              'text-on-primary-container':
                                !item.color && !item.active,
                              'text-primary-900': !item.color && item.active
                            }"
                            class="fa-solid {{ item.icon }} text-[20px]"
                          ></i>
                        </div>

                        @if (item.iconSecondary) {
                          <div
                            class="absolute bottom-[5px] right-[12px] flex h-3 w-3 items-center justify-center"
                          >
                            <i class="{{ item.iconSecondary }} text-xxs"></i>
                          </div>
                        }

                        @if (
                          item.beta && mode() === NavigationBarMode.FLOATING
                        ) {
                          <div
                            class="absolute bottom-[-2px] right-[2px] h-3 w-3 aspect-square flex items-center justify-center rounded-sm bg-yellow-400 text-[8px] font-semibold leading-none text-slate-900 transition-opacity group-hover/nav:opacity-0"
                          >
                            B
                          </div>
                        }
                      </div>

                      <div
                        class="flex flex-row items-center ml-1 flex-1 rounded-md whitespace-nowrap"
                      >
                        <span
                          class="text-sm select-none text-slate-600 group-hover:text-slate-900 transition-colors"
                          [ngClass]="{
                            'text-primary-900': item.active
                          }"
                          >{{ item.title }}</span
                        >

                        @if (item.beta) {
                          <div
                            class="ml-auto rounded-sm p-[1px] bg-yellow-400 text-slate-900 text-xxs mr-1 flex flex-row items-center justify-center"
                          >
                            <span>BETA</span>
                          </div>
                        }

                        @if (shouldShowPrimaryMenuLock(item)) {
                          <i
                            class="fa-light fa-lock text-xs text-slate-400 ml-auto mr-1"
                            [attr.aria-label]="'Sezione protetta' | transloco"
                          ></i>
                        }
                      </div>

                      @if (!item.disabled && (item.items?.length || 0) > 1) {
                        <div class="flex items-center p-1">
                          <div
                            class="flex items-center justify-center w-6 h-6 opacity-0 group-hover:opacity-100"
                          >
                            <i
                              class="transition-transform fa-light fa-chevron-left text-slate-400"
                              [ngClass]="{
                                '-rotate-90':
                                  currentOpenedMenu?.index === $index
                              }"
                            ></i>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>

                <!-- submenu -->
                <div class="flex flex-row gap-1 pl-2 pr-2">
                  <div
                    class="w-px transition-colors rounded-full bg-slate-200"
                  ></div>

                  <div
                    #subMenuContainer
                    class="grid flex-1 transition-all"
                    [ngClass]="{
                      'py-0': item && (item.items?.length || 0) > 0
                    }"
                    style="grid-template-rows: 0fr; gap: 4px"
                  >
                    <div
                      #subMenuWrapper
                      class="flex flex-col gap-[0px]"
                      style="overflow: hidden"
                    >
                      @for (
                        subItem of item.items;
                        track (subItem.url || subItem.title + $index) +
                          protectedRoutesRevision()
                      ) {
                        <div
                          [ngClass]="{
                            '[&:not(:first-child)]:mt-2': subItem.header
                          }"
                          class="relative flex flex-row overflow-visible select-none"
                        >
                          <div
                            [ngClass]="{
                              'cursor-pointer':
                                !subItem.disabled && !subItem.header,
                              'cursor-not-allowed': subItem.disabled,
                              'opacity-50': subItem.disabled,
                              'hover:bg-slate-200': !subItem.header,
                              'font-medium': subItem.header
                            }"
                            class="flex flex-row items-center flex-1 gap-1 p-1 transition-colors rounded-md"
                            (click)="
                              !subItem.header &&
                                !subItem.disabled &&
                                onMenuItemClick(subItem)
                            "
                          >
                            <a
                              [attr.href]="subItem.url"
                              onclick="return false;"
                              class="flex flex-row items-center flex-1 gap-1"
                              [ngClass]="{
                                'cursor-pointer':
                                  !subItem.disabled && !subItem.header
                              }"
                            >
                              @if (subItem.icon) {
                                <div
                                  [ngStyle]="{
                                    backgroundColor: subItem.active
                                      ? item.color || null
                                      : null
                                  }"
                                  class="relative flex items-center justify-center w-6 h-6 rounded-md"
                                >
                                  <i
                                    [ngStyle]="{
                                      color: !subItem.active
                                        ? item.color || null
                                        : null
                                    }"
                                    [ngClass]="{
                                      'text-slate-50': subItem.active
                                    }"
                                    class="fa-solid fa-duotone {{
                                      subItem.icon
                                    }} "
                                  ></i>
                                </div>
                              }

                              <span
                                class="text-xs text-slate-600 hover:text-slate-900"
                                >{{ subItem.title }}</span
                              >

                              @if (subItem.newFeatureName) {
                                <snt-notify-new-content
                                  [name]="subItem.newFeatureName"
                                  [small]="true"
                                  class="ml-auto"
                                ></snt-notify-new-content>
                              }

                              @if (
                                isMenuItemProtected(subItem) &&
                                (item.items?.length || 0) > 1
                              ) {
                                <i
                                  class="fa-light fa-lock text-xs text-slate-400 ml-auto mr-1"
                                  [attr.aria-label]="
                                    'Sezione protetta' | transloco
                                  "
                                ></i>
                              }
                            </a>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <!-- status & updet icons -->
        <div class="flex flex-col gap-2 mt-auto">
          <div class="flex flex-col gap-1 border-t border-slate-200 pt-2">
            @if (scannerStatus() === "enabled") {
              <div
                class="flex items-center justify-center w-10 cursor-pointer"
                tabindex="0"
                role="status"
                [attr.aria-label]="'Barcode scanner attivo' | transloco"
              >
                <div
                  [sntTooltip]="'Barcode scanner attivo' | transloco"
                  [placement]="'top'"
                  class="relative h-7 w-7 flex items-center justify-center"
                >
                  <div
                    class="relative flex items-center justify-center h-7 w-7"
                  >
                    <span
                      class="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-800"
                    ></span>

                    <div>
                      <i
                        class="text-[14px] fa-light fa-scanner-gun text-on-primary-container"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            }

            @if (
              product === SoftwareProduct.PMS ||
              product === SoftwareProduct.ROCKET ||
              product === SoftwareProduct.ADMIN
            ) {
              <!-- update status -->
              <div class="flex flex-row items-center justify-center w-10">
                @let _updateStatus = updateStatus();

                <div
                  class="relative"
                  tabindex="0"
                  role="button"
                  (click)="onUpdateStatusClick()"
                  (keydown.enter)="onUpdateStatusClick()"
                  (keydown.space)="onUpdateStatusClick()"
                  [sntTooltip]="
                    _updateStatus === UpdateServiceStatus.UPDATE_READY
                      ? ('Aggiornamento disponibile' | transloco)
                      : _updateStatus === UpdateServiceStatus.UPDATING
                        ? ('Aggiornamento in corso' | transloco)
                        : _updateStatus === UpdateServiceStatus.CHECK
                          ? ('Verifica aggiornamenti' | transloco)
                          : _updateStatus === UpdateServiceStatus.UPDATE_ERROR
                            ? ('Errore aggiornamento' | transloco)
                            : ('Sistema aggiornato' | transloco)
                  "
                  [placement]="'top'"
                  [attr.aria-label]="
                    _updateStatus === UpdateServiceStatus.UPDATE_READY
                      ? ('Aggiornamento disponibile' | transloco)
                      : _updateStatus === UpdateServiceStatus.UPDATING
                        ? ('Aggiornamento in corso' | transloco)
                        : _updateStatus === UpdateServiceStatus.CHECK
                          ? ('Verifica aggiornamenti' | transloco)
                          : _updateStatus === UpdateServiceStatus.UPDATE_ERROR
                            ? ('Errore aggiornamento' | transloco)
                            : ('Sistema aggiornato' | transloco)
                  "
                >
                  <i
                    [ngClass]="{
                      'text-warning':
                        _updateStatus === UpdateServiceStatus.CHECK,
                      'text-slate-400':
                        _updateStatus === UpdateServiceStatus.DISABLED,
                      'text-error':
                        _updateStatus === UpdateServiceStatus.UPDATE_ERROR,
                      'text-success':
                        _updateStatus === UpdateServiceStatus.STANDBY ||
                        _updateStatus === UpdateServiceStatus.UPDATING,
                      'text-blue-600':
                        _updateStatus === UpdateServiceStatus.UPDATE_READY,
                      'animate-pulse':
                        _updateStatus === UpdateServiceStatus.CHECK ||
                        _updateStatus === UpdateServiceStatus.UPDATING
                    }"
                    class="text-[14px] fa-light fa-truck-fast"
                  ></i>

                  @if (_updateStatus === UpdateServiceStatus.UPDATING) {
                    <div class="absolute -right-1 -top-1">
                      <i
                        class="text-orange-600 fa-solid fa-circle-down text-xs"
                      ></i>
                    </div>
                  }

                  @if (_updateStatus === UpdateServiceStatus.UPDATE_READY) {
                    <div class="absolute -right-1 -top-1">
                      <i
                        class="text-blue-600 fa-solid fa-circle-exclamation text-xs"
                      ></i>
                    </div>
                  }
                </div>
              </div>

              <!-- box status -->
              <snt-navigation-bar-box-status></snt-navigation-bar-box-status>
            }

            <!-- sse status -->
            @let _serverEventsStatus = serverEventsStatus();
            <div
              class="flex items-center justify-center w-10 cursor-pointer"
              tabindex="0"
              role="status"
              [sntTooltip]="
                _serverEventsStatus === 'connected'
                  ? ('Connessione in tempo reale attiva' | transloco)
                  : ('Connessione in corso...' | transloco)
              "
              [placement]="'top'"
              [attr.aria-label]="
                _serverEventsStatus === 'connected'
                  ? ('Connessione in tempo reale attiva' | transloco)
                  : ('Connessione in corso...' | transloco)
              "
            >
              <span>
                <i
                  #iconSSEStatus
                  class="text-[14px] fa-light fa-signal-stream"
                  [ngClass]="{
                    'text-success': _serverEventsStatus === 'connected',
                    'animate-pulse text-error':
                      _serverEventsStatus === 'connecting'
                  }"
                ></i>
              </span>
            </div>
          </div>

          <div class="flex border-t border-slate-200 pt-2">
            <div class="relative flex-1 flex flex-row">
              <div
                class="absolute left-0 top-0 bottom-0 right-0 flex justify-center items-center"
              >
                <div #tooltipTarget class="text-center text-slate-400 p-2">
                  <span class="text-xs font-bold">{{ productVersion }}</span>
                  @if (isStaging && commitHash) {
                    <span class="text-xxs font-normal text-slate-400">
                      · {{ commitHash.slice(0, 7) }}</span
                    >
                  }
                  <br />
                  <span class="text-xxs italic"
                    >© {{ currentYear }} Snoots S.r.l.</span
                  >
                </div>

                @if (isStaging) {
                  <dx-tooltip
                    [target]="tooltipTarget"
                    [showEvent]="'mouseenter'"
                    [hideEvent]="'mouseleave'"
                  >
                    <div
                      *dxTemplate="let data of 'content'"
                      class="p-2 flex flex-col"
                    >
                      <div>
                        <span class="text-xs">Build: {{ buildNumber }}</span>
                      </div>

                      <div>
                        <span class="text-xs">Branch: {{ branch }}</span>
                      </div>

                      @if (commitHash) {
                        <div>
                          <span class="text-xs">Commit: {{ commitHash }}</span>
                        </div>
                      }
                    </div>
                  </dx-tooltip>
                }
              </div>

              <div class="z-10">
                <snt-navigation-bar-status-page></snt-navigation-bar-status-page>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template>
      <div class="ml-0 ml-1 ml-2 ml-3 ml-4 ml-5"></div>
    </ng-template>

    <ng-template #menu let-items let-depth="depth">
      <div
        *ngFor="let item of items"
        (click)="
          $event.stopImmediatePropagation();
          !item.disabled && onMenuItemClick(item)
        "
      >
        <div
          class="ml-{{ 2 + depth * 2 }} select-none"
          [ngClass]="{
            'cursor-pointer': item.url && !item.disabled,
            'cursor-not-allowed opacity-50': item.disabled
          }"
        >
          <div
            class="flex flex-row px-2 py-2 mx-1 my-1 text-sm transition-colors duration-300 rounded-md text-on-primary-container hover:bg-slate-200"
          >
            <div *ngIf="item.icon">
              <i class="w-5 {{ item.icon }}"></i>
            </div>

            <div class="relative flex-1">
              <div
                class="absolute inset-0 overflow-hidden text-ellipsis whitespace-nowrap"
              >
                <span class="ml-2">{{ item.title }}</span>
              </div>

              <div
                class="absolute top-0 bottom-0 right-0 transition-all rounded-bl-md rounded-tl-md bg-slate-800"
                [ngClass]="{ 'w-0': !item.active, 'w-1': item.active }"
              ></div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="item.items && item.items.length > 0">
          <ng-container
            [ngTemplateOutlet]="menu"
            [ngTemplateOutletContext]="{
              $implicit: item.items,
              depth: depth + 1
            }"
          ></ng-container>
        </ng-container>
      </div>
    </ng-template>
  }
}
